<template>
  <div class="pop-up">
    <ResultsPopup v-if="showPopup" @close="close" />
    <LoadingPopup v-if="!dataLoaded" />
  </div>

  <div v-if="dataLoaded" :class="showPopup ? 'active-blur main-div' : 'main-div'">
    <NavContainer :data="data" :currentCategory="currentDomain.category" @updateDomain="updateDomain" />

    <div class="questionnaire-container">
      <QuestionnaireHeader @updateQuestions="updateQuestions" :category="currentDomain.category" :categoryName="currentDomain.categoryName"
        :category-desc="currentDomain.categoryDescription" />

      <div>
        <div v-for="(question, i) in currentQuestions" :key="i + currentDomain" class="question-list">
          <Question :question="question" :count="i + 1"></Question>
        </div>
      </div>


      <div class="footer">
        <div class="navigation-buttons">
          <button class="btn btn-outline-dark back" type="submit" @click="updateDomain(-1)"
            v-if="currentDomainCount !== 0">
            {{ $t('back') }}
          </button>
        </div>

        <div class="navigation-buttons">
          <button v-if="this.data[this.currentDomainCount + 1] !== undefined" class="btn btn-outline-dark next"
            type="submit" @click="updateDomain(1)">
            {{ $t('next') }}
          </button>

          <div class="more-information-container dropdown">
            <button class="btn btn-outline-dark next" type="submit" @click="endQuiz()" :disabled="areAllAnswered">
              {{ $t('end') }}
            </button>
            <div class="dropdown-content" v-if="areAllAnswered">
              <div>{{ $t("incomplete") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionnaireHeader from './QuestionnaireHeader.vue';
import Question from './Question.vue';
import NavContainer from './NavContainer.vue';
import ResultsPopup from '../Popups/ResultsPopup.vue'
import LoadingPopup from '../Popups/LoadingPopup.vue'
import axios from "axios";

export default {
  name: "Questionnaire",
  components: {
    QuestionnaireHeader,
    Question,
    NavContainer,
    ResultsPopup,
    LoadingPopup
  },
  data() {
    return {
      data: {},
      currentDomain: {},
      currentQuestions: [],
      currentDomainCount: 0,
      summary: {},
      showPopup: false,
      dataLoaded: false,
      validated: true,
      areAllAnswered: true,
      labels: ["ISMS",
        "APP",
        "SYS",
        "IND",
        "NET",
        "INF",
        "DER",
        "OPS",
        "CON",
        "ORP"]
    };
  },
  watch: {
    '$store.state.answers': {
      deep: true,
      handler() {
        let areAllAnswered = 1;
        this.$store.state.metadata.questionnaire[this.currentDomainCount].questions.forEach(element => {
          if (this.$store.state.answers[element.id] === undefined) {
            areAllAnswered = 0;
          }
        })
        this.$store.state.navState[this.currentDomain.category] = areAllAnswered;
        this.checkAnswerStatus();

        const currentdate = new Date();
        const day = currentdate.getDate() < 10 ? "0" + currentdate.getDate() : currentdate.getDate();
        const month = currentdate.getMonth() < 9 ? "0" + (currentdate.getMonth() + 1) : (currentdate.getMonth() + 1)
        const datetime = day + "." + month + "." + currentdate.getFullYear();

        this.$store.commit("addDate", datetime)
        //console.log(this.$store.state.lastChangeDate)
      }
    }
  },
  methods: {
    updateQuestions(version){
      this.$store.commit("updateVersionAnswers")
      axios
          .get('https://mass.cloud.ut.ee/mass-v0/mass/'+version)
          .then(response => {
            this.$store.commit("addMetadata", response.data)
            this.$store.state.summary['version'] = response.data.version;
            this.$store.state.answers['version'] = response.data.version;
            this.$store.commit("addAnswers");
            // this.$store.state.benchmark = [];
            this.data = this.$store.state.metadata.questionnaire;
            this.checkAnswerStatus();
            this.updateDomain(this.currentDomainCount, true);
          }).catch(function (error) {
        console.log("Failed to load data: ", error);


      })
    },
    checkAnswerStatus() {
      let state = false;

      for (const key in this.$store.state.navState) {
        if (this.$store.state.navState[key] === 0) {
          state = true;

        }
      }
      this.areAllAnswered = state;

    },
    updateDomain(index, chapter) {
      if (chapter) this.currentDomainCount = index;
      else this.currentDomainCount = this.currentDomainCount + index;
      this.currentDomain = this.data[this.currentDomainCount];
      this.currentQuestions = this.currentDomain['questions'];
      window.scrollTo(0, 0);
    },

    close() {
      this.showPopup = false;
      this.showIntroduction = false;
    },
    endQuiz() {
      if (this.$store.state.navState.includes(0)) {
        this.showPopup = true;

      } else {
        this.calculateResults()
      }
    },
    calculateResults() {
      this.$store.commit("addSummary", {})
      let answers = this.$store.state.answers;

      this.data.forEach(item => {
        this.summary[item.category] = [[], [], []];

        item['questions'].forEach(question => {
          let value = parseInt(answers[question.id]);
          if (value > -1) {
            let level = question.level - 1
            let current = isNaN(this.summary[item.category][0][level]) ? 0 : this.summary[item.category][0][level]
            let count = isNaN(this.summary[item.category][1][level]) ? 0 : this.summary[item.category][1][level]
            this.summary[item.category][0][level] = value + current
            this.summary[item.category][1][level] = count + 1
          }
        })
        for (let i = 0; i < 4; i++) {
          this.summary[item.category][2][i] = isNaN(this.summary[item.category][0][i]) ? null : Math.round(this.summary[item.category][0][i] / this.summary[item.category][1][i] * 100) / 100
        }

      })
      this.$store.commit("addSummary", this.summary)
      var initial = []
      var defined = []
      var basic = []
      var standard = []
      var summary = []
      
      this.labels.forEach(label => {

        let sum = null;
        let nullCount = 0;
        this.$store.state.summary[label][2].forEach(i => {
          if (i !== null) sum += i
          else nullCount++;
        })
        if (sum === null) {
          summary.push(null)
        } else summary.push(Math.round(sum / (4 - nullCount) * 100) / 100)

        initial.push(this.$store.state.summary[label][2][0])
        defined.push(this.$store.state.summary[label][2][1])
        basic.push(this.$store.state.summary[label][2][2])
        standard.push(this.$store.state.summary[label][2][3])
      })

      this.$store.state.calculatedSummaryData = {
        "initial": initial,
        "defined": defined,
        "basic": basic,
        "standard": standard,
        "result": summary,
        "order": this.labels,
        "version": this.$store.state.metadata.version
      }

      window.scrollTo(0, 0);
      //this.$router.push('/results')
      this.$router.push('/sendResults')
    },
  },
  mounted() {
    this.data = this.$store.state.metadata.questionnaire;
    this.currentDomain = this.data[0];
    this.currentQuestions = this.currentDomain['questions'];
    this.dataLoaded = true;
    this.checkAnswerStatus();
  }
}
</script>
<style scoped lang="scss">
.main-div {
  display: flex;
}

.questionnaire-container {
  background-color: #ffff;
  padding: 1rem;
  margin-left: 170px;
  width: 90%;
  min-width: 1200px;
}


.footer {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 10px;
  padding: 60px 10px 10px 0;
}

.navigation-buttons {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  gap: 70px;
}


.question-list {
  padding: 2rem;
}

.pop-up {
  position: absolute;
  top: 20%;
  left: 35%;
}

.active-blur {
  filter: blur(2px) !important;
}


.more-information {
  cursor: pointer;
  font-size: 0.7rem;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 210px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 15px 20px;
  z-index: 1;
}

.dropdown:hover .dropdown-content {
  display: block;
  margin-top: -130px;
}
</style>
